// extracted by mini-css-extract-plugin
module.exports = {"title":"AccommodationDetailed_title___sNwG","stars":"AccommodationDetailed_stars__FOEK4","roomTypeWrap":"AccommodationDetailed_roomTypeWrap__X7yrG"};